// services/everpro/everpro-balance.ts — saldo akun Everpro per-brand via S2 proxy
import { everproFetch } from './everpro-auth';

export interface EverproBalance {
  cash: number;
  name: string;
}

export async function getEverproBalance(brandId: string): Promise<EverproBalance | null> {
  if (!brandId) return null;

  try {
    const res = await everproFetch(brandId, '/balance/v1/detail', { method: 'GET' });
    if (!res.ok) return null;
    const json = await res.json();
    const d = json?.data ?? {};
    if (d.cash == null && !d.name) return null;
    return { cash: Number(d.cash) || 0, name: d.name || '' };
  } catch {
    return null;
  }
}
